import React, { Component } from "react";
import Modal from "reactstrap/es/Modal";
import { ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import axios from "axios";
import { APIURL, CAR_TYPE_PATH } from "../../../config/config";
import { AlertWarning } from "../../Alert/Alert";
import { NumberUtil } from "../../../utils/number-util";

// 'GE', 'TA', 'KK', 'OLI'
class CarFind2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      car_structure_selected: [],
      car_structure: [],
      car_down_range_id: 1,
      car_down_range: [
        {
          car_down_range_id: 1,
          car_down_range_min: 3000,
          car_down_range_max: 4999,
          car_price_min: 100000,
          car_price_max: 249000,
        },
        {
          car_down_range_id: 2,
          car_down_range_min: 5000,
          car_down_range_max: 6999,
          car_price_min: 250000,
          car_price_max: 329000,
        },
        {
          car_down_range_id: 3,
          car_down_range_min: 7000,
          car_down_range_max: 7999,
          car_price_min: 330000,
          car_price_max: 399000,
        },
        {
          car_down_range_id: 4,
          car_down_range_min: 8000,
          car_down_range_max: 8999,
          car_price_min: 400000,
          car_price_max: 459000,
        },
        {
          car_down_range_id: 5,
          car_down_range_min: 9000,
          car_down_range_max: 9999,
          car_price_min: 460000,
          car_price_max: 499000,
        },
        {
          car_down_range_id: 6,
          car_down_range_min: 10000,
          car_down_range_max: "ขึ้นไป",
          car_price_min: 500000,
          car_price_max: "ขึ้นไป",
        },
      ],
      installmentInfo: {},
    };
    this.toggle = this.toggle.bind(this);
    this.carFindCriteria = this.carFindCriteria.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.loadCarBankLeasing = this.loadCarBankLeasing.bind(this);
    this.loadCarStructureWithImageData =
      this.loadCarStructureWithImageData.bind(this);
    this.onChangeCarStructure = this.onChangeCarStructure.bind(this);
    this.calculateInstallments = this.calculateInstallments.bind(this);
    this.renderInstallmentInfo = this.renderInstallmentInfo.bind(this);
  }

  componentDidMount() {
    this.loadCarStructureWithImageData();
  }

  loadCarStructureWithImageData() {
    axios
      .get(APIURL + "/car_structure/image")
      .then((res) => {
        this.setState({ car_structure: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ car_structure: [] });
      });
  }

  onChangeCarStructure(car_structure) {
    let car_structure_id = car_structure.car_structure_id;
    let car_structure_select =
      car_structure.car_structure_select === "select" ? "not_select" : "select";
    if (car_structure.car_structure_select) {
    }
    let car_structure_list = this.state.car_structure.map((cs) =>
      cs.car_structure_id === car_structure_id
        ? { ...cs, car_structure_select: car_structure_select }
        : cs
    );
    //
    let car_structure_selected = [];
    car_structure_list
      .filter((cs) => cs.car_structure_select === "select")
      .map((cs) => {
        let car_structure_id = cs.car_structure_id;
        car_structure_selected.push(car_structure_id);
      });

    // คำนวณยอดผ่อนสำหรับรถที่เลือก
    const installmentInfo = { ...this.state.installmentInfo };
    const car_name = car_structure.car_structure_name;

    if (car_structure_select === "select") {
      // เลือกรถ - คำนวณยอดผ่อน
      const interestRate =
        car_structure.car_structure_group === "กระบะ" ||
        car_structure.car_structure_group === "ตอนเดียว"
          ? 0.07
          : 0.05;
      const installmentData = this.calculateInstallments(
        car_structure.min_price,
        car_structure.max_price,
        car_structure.car_structure_group
      );

      if (installmentData) {
        installmentInfo[car_name] = {
          ...installmentData,
          interestRate,
        };
      }
    } else {
      // ยกเลิกการเลือกรถ - ลบข้อมูลออกจาก installmentInfo
      delete installmentInfo[car_name];
    }

    this.setState({
      car_structure: car_structure_list,
      car_structure_selected,
      installmentInfo,
    });
  }

  /*componentDidUpdate (prevProps, prevState, snapshot) {
    if(prevState.leasingBanks.length === 0) {
      // this.loadCarBankLeasing()
    }
  }*/

  toggle() {
    // let toggle_car_find = !this.props.toggle_car_find
    this.props.handleCarFind(false, null);
  }

  carFindCriteria() {
    let car_down_range_id = Number(this.state.car_down_range_id);
    let car_structure_selected = this.state.car_structure_selected;
    let car_down_range = this.state.car_down_range.filter(
      (car_down_range) => car_down_range.car_down_range_id === car_down_range_id
    )[0];

    const data = {
      car_down_range,
      car_structure_selected,
      installmentInfo: this.state.installmentInfo,
    };
    console.log(car_down_range);

    this.props.handleCarFind(false, data);
  }

  onInputChange(event) {
    event.preventDefault();

    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  loadCarBankLeasing() {
    /*
    axios.get(APIURL + '/car_leasing/banks')
      .then(res => {
        this.setState({leasingBanks: res.data})
      }).catch(error => {
      this.setState({leasingBanks: []})
    })*/
  }

  calculateInstallments(minPrice, maxPrice, carStructureGroup) {
    if (!minPrice || !maxPrice) {
      return null;
    }

    // กำหนดอัตราดอกเบี้ย
    const interestRate =
      carStructureGroup === "กระบะ" || carStructureGroup === "ตอนเดียว"
        ? 0.07
        : 0.05;

    // คำนวณยอดผ่อนต่ำสุด (ไม่รวม VAT)
    const minInstallmentNoVAT = (minPrice * interestRate * 6 + minPrice) / 72;
    // คำนวณยอดผ่อนสูงสุด (ไม่รวม VAT)
    const maxInstallmentNoVAT = (maxPrice * interestRate * 6 + maxPrice) / 72;

    // บวก VAT 7%
    const minInstallment = minInstallmentNoVAT * 1.07;
    const maxInstallment = maxInstallmentNoVAT * 1.07;

    return {
      minPrice,
      maxPrice,
      minInstallment,
      maxInstallment,
    };
  }

  renderInstallmentInfo() {
    const installments = Object.entries(this.state.installmentInfo);

    if (installments.length === 0) {
      return (
        <div className="row pt-3">
          <div className="col-12">
            <div className="alert alert-info" style={{ textAlign: "center" }}>
              <small>กรุณาเลือกรถเพื่อคำนวณยอดผ่อน</small>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="row pt-3">
        <div className="col-12">
          <div className="card" style={{ backgroundColor: "#f8f9fa" }}>
            <div className="card-body">
              <h6
                className="card-title mb-3 mt-2 "
                style={{ color: "#2c3e50" }}
              >
                <i className="fas fa-calculator mr-2"></i>
                คำนวณยอดผ่อนรถยนต์
              </h6>
              {installments.map(([carName, info]) => (
                <div
                  key={carName}
                  className="mb-3 p-3"
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <div className="row">
                    <div className="col-md-6">
                      <strong style={{ color: "#495057" }}>{carName}</strong>
                      <div className="text-muted mt-1">
                        <small>
                          ราคา {NumberUtil.addCommasZeroInt(info.minPrice)} -{" "}
                          {NumberUtil.addCommasZeroInt(info.maxPrice)} บาท
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6 text-md-right">
                      <div className="text-success">
                        <strong>ผ่อนเริ่มต้น: </strong>
                        {NumberUtil.addCommasZeroInt(
                          Math.round(info.minInstallment)
                        )}{" "}
                        -{" "}
                        {NumberUtil.addCommasZeroInt(
                          Math.round(info.maxInstallment)
                        )}
                        <small> บาท/เดือน</small>
                      </div>
                      <div className="text-muted mt-1">
                        <small>
                          *อัตราดอกเบี้ย{" "}
                          {info.interestRate === 0.07 ? "7%" : "5%"} (รวม VAT
                          7%)
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    // const carTypes = this.state.carTypes.map((carType, index) => (
    //   <option key={index} value={carType}>{carType}</option>
    // ))

    /*const leasingBanks = this.state.leasingBanks.map((leasingBank, index) => (
      <option key={index} value={leasingBank}>{leasingBank}</option>
    ))*/

    const carDownRangelist = this.state.car_down_range.map((per, index) => {
      let car_down_range_min =
        typeof per.car_down_range_min === "number"
          ? NumberUtil.addCommasZeroInt(String(per.car_down_range_min))
          : per.car_down_range_min;
      let car_down_range_max =
        typeof per.car_down_range_max === "number"
          ? NumberUtil.addCommasZeroInt(String(per.car_down_range_max))
          : per.car_down_range_max;
      let range = car_down_range_min + " - " + car_down_range_max;
      return (
        <option key={index} value={per.car_down_range_id}>
          {range}
        </option>
      );
    });

    /*const proOptions = this.state.promotionOptions.map((option, index) => (
      <option key={index} value={option.value}>{option.label}</option>
    ));*/

    // let image_url = CAR_TYPE_PATH+'1_เก๋งตอนเดียว.png'

    const carStructureImage = this.state.car_structure.map(
      (car_structure, index) => {
        // let car_structure_id = car_structure.car_structure_id;
        let car_structure_name = car_structure.car_structure_name;
        let car_structure_group = car_structure.car_structure_group;
        let car_structure_image = car_structure.car_structure_image;
        let car_structure_select = car_structure.car_structure_select;
        let car_structure_count = car_structure.car_structure_count;
        let image_url = CAR_TYPE_PATH + car_structure_image;
        // style={{backgroundColor: '#c0c0c0'}}
        let bgColor =
          car_structure_select === "not_select" ? "#f8f6f6" : "#9FC69F";

        return (
          <div
            key={index}
            style={{ width: "124px", marginRight: "20px" }}
            onClick={() => {
              this.onChangeCarStructure(car_structure);
            }}
          >
            <div className="card" style={{ backgroundColor: bgColor }}>
              <div
                className="card-block p-3 clearfix text-center"
                style={{ overflow: "hidden" }}
              >
                <img
                  src={image_url}
                  style={{
                    cursor: "pointer",
                    width: 60,
                    height: "auto",
                    marginTop: 8,
                  }}
                  alt="car_type"
                />
                <br />

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <span
                    className="text-nowrap"
                    style={{ overflow: "hidden", fontSize: 12 }}
                  >
                    {car_structure_name}{" "}
                    {car_structure_group === "" ||
                    car_structure_group === null ? (
                      <span style={{ textAlign: "center" }}>
                        {" "}
                        จ.น. {car_structure_count} คัน
                      </span>
                    ) : null}
                  </span>
                  {car_structure_group && (
                    <span style={{ textAlign: "center" }}>
                      จ.น. {car_structure_count} คัน - ({car_structure_group})
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      }
    );

    // className={'modal-lg xs'}
    return (
      <Modal
        isOpen={this.props.toggle_car_find}
        toggle={this.toggle}
        size={"xl"}
        className={"modal-lg"}
        style={{ maxWidth: "960px" }}
        scrollable
      >
        <ModalHeader toggle={this.toggle}>ค้นหารถตามลักษณะรถ</ModalHeader>
        <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div className="row mb-1">
            <div className="col-3">
              <strong> เลือกลักษณะรถ : </strong>
            </div>
            <div className="col-8"></div>
          </div>
          <div className="row  px-3">{carStructureImage}</div>
          <div className="row pt-2">
            <div className="col-3 text-right">ค่าผ่อนรถต่อเดือน :</div>
            <div className="col-8">
              <select
                name="car_down_range_id"
                className="form-control"
                value={this.state.car_down_range_id}
                onChange={this.onInputChange}
              >
                {carDownRangelist}
              </select>
            </div>
          </div>

          {/* ส่วนแสดงผลการคำนวณยอดผ่อน */}
          {this.renderInstallmentInfo()}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.carFindCriteria}>
            ตกลง
          </Button>{" "}
          <Button color="secondary" onClick={this.toggle}>
            ยกเลิก
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default CarFind2;
